<div class="scrollbar dwo  ">
    <div class="border mb15 position-relative">
        <div class="table-responsive max-h357" infinite-scroll [infiniteScrollDistance]="scrollDistance"
            [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown($event)">
            <table class="tablest1">
                <thead style="position: sticky;top:0">
                    <tr>
                        <th style="width: 7%" scope="col" sortable="WorkOrderNumber" (sort)="onSort($event)" translate>
                            lblWoNo</th>
                        <th style="width: 7%" scope="col" translate>lblWoStatus</th>
                        <th style="width: 15%" scope="col" translate>lblDescription</th>
                        <th style="width: 7%" scope="col" translate>lblKilometer</th>
                        <th style="width: 20%" scope="col" translate>lblCustomer</th>
                        <th style="width: 10%" scope="col" sortable="CreatedDate" (sort)="onSort($event)" translate>
                            lblCreatedDate</th>
                        <th style="width: 10%" scope="col" sortable="StartDate" (sort)="onSort($event)" translate>
                            lblBookedDate</th>
                        <th style="width: 20%" scope="col" translate>lblDealersName</th>
                        <th scope="col" style="width:80px" translate class="text-center">lblReason</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="historicalWorkOrdersList?.length>0; else load_else">
                        <ng-container *ngFor="let wo of historicalWorkOrdersList; let i=index" >
                            <tr [ngStyle]="{'color': wo.isDeleted ? '#f12e05' : ''}">
                                <td>
                                    <a class="link-primary" (click)="OpenEditView(wo)">{{wo.workOrderNumber}}</a>
                                </td>
                                <td>
                                    <ngb-highlight [result]="wo.status">{{wo.status}}
                                    </ngb-highlight>
                                </td>
                                <td>
                                    <ngb-highlight [result]="wo.description">{{wo.description}}
                                    </ngb-highlight>
                                </td>
                                <td>
                                    <ngb-highlight [result]="wo.kilometer">{{wo.kilometer}}
                                    </ngb-highlight>
                                </td>
                                <td>
                                    <ngb-highlight [result]="wo.customerName">{{wo.customerName}}
                                    </ngb-highlight>
                                </td>
                                <td>
                                    <ngb-highlight [result]="wo.entryDate">{{wo.entryDate}}
                                    </ngb-highlight>
                                </td>
                                <td>
                                    <ngb-highlight [result]="wo.workOrderDate">
                                        {{wo.workOrderDate}}
                                    </ngb-highlight>
                                </td>
                                <td>
                                    <ngb-highlight [result]="wo.dealer">{{wo.dealer}}
                                    </ngb-highlight>
                                </td>
                                <td class="nowrap text-center">
                                    <a class="btn btn-ico"  *ngIf="wo.reasonForDeletion" ngbTooltip="{{wo.reasonForDeletion}}">
                                        <em class="fas fa-info-circle fa-lg"></em>
                                    </a>
                                    <span class="ico-div" *ngIf="wo.reasonForCancellation"></span>
                                    <a class="btn btn-ico" *ngIf="wo.reasonForCancellation" ngbTooltip="{{wo.reasonForCancellation}}">
                                        <em class="fas fa-times-circle fa-lg"></em>
                                    </a>
                                </td>
                            </tr>
                        </ng-container>
                    </ng-container>
                    <ng-template #load_else>
                        <tr>
                            <td colspan="12" class="no-record" translate>lblNoRecordsFound</td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="p-3 bg-light pp-footer-top-brdr">
    <div class="d-flex flex-sm-row flex-column justify-content-end">
        <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg mb-1" translate>
            <em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
    </div>
</div>